export const isArray = <T>(arg?: any): arg is T[] => Array.isArray(arg);
